import React from "react";
import Direction from "@/components/atomics/direction";

interface StepButtonProps {
  className?: string;
  currentIndex: number;
  totalIndex: number;
  onPreviousStep: () => void;
  onNextStep: () => void;
  onFinish: () => void;
}

const StepButton = ({
  className,
  currentIndex,
  totalIndex,
  onPreviousStep,
  onNextStep,
  onFinish,
}: StepButtonProps) => {
  const handlePreviousStep = () => {
    onPreviousStep();
  };

  const handleNextStep = () => {
    onNextStep();
  };

  const handleNext = () => {
    if (currentIndex < totalIndex - 1) {
      onNextStep();
    } else {
      onFinish();
    }
  };

  return (
    <div
      className={`${className} flex items-center justify-center relative mx-[20px] pt-[10px]`}
    >
      <div
        className="text-primary text-[32px] hover:cursor-pointer"
        onClick={() => {
          handleNext();
        }}
      >
        {currentIndex === totalIndex - 1 ? "GOT IT" : "NEXT"}
      </div>
      <div className="absolute left-[0px]">
        {currentIndex > 0 && (
          <Direction
            className="w-[17px] h-[29px] rotate-180 hover:cursor-pointer"
            color="#0099FE"
            onClick={() => {
              handlePreviousStep();
            }}
          />
        )}
      </div>
      <div className="absolute right-[0px]">
        {currentIndex < totalIndex - 1 && (
          <Direction
            className="w-[17px] h-[29px] hover:cursor-pointer"
            color="#0099FE"
            onClick={() => {
              handleNextStep();
            }}
          />
        )}
      </div>
    </div>
  );
};

export default StepButton;
